export default "__VITE_ASSET__5850478e__"